module.exports = __webpack_public_path__ + "static/img/node_mention.17b97aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/tutorial/img/node_mention.png
// module id = t61v
// module chunks = 1